module.exports = __webpack_public_path__ + "static/media/Outdoor3.f3ad422e.jpg";